export default "__VITE_ASSET__BpRAHgSn__"